/*
 * AU only: the PBS fields for one medication in the medication modal - quantity, repeats, brand
 * substitution and authority details - printed onto the pre-printed PBS/RPBS prescription form.
 *
 * Writes straight onto the medication form's model; AuPrescriptionFieldsService reads them back.
 */
app.component("auPrescriptionItemDetails", {
	templateUrl: "app/src/js/components/medications/au/AuPrescriptionItemDetails.html",
	controller: "auPrescriptionItemDetailsController",
	bindings: {
		form: "=",
	},
});

app.controller("auPrescriptionItemDetailsController", [
	"$scope",
	function ($scope) {
		// Authority-only fields stay disabled or hidden until an authority number or streamlined code is entered.
		$scope.isAuthority = function () {
			const form = $scope.$ctrl.form;
			return !!(form && (form.pbs_authority_number || form.streamlined_authority_code));
		};
	},
]);
